export const ATTRIBUTE_NAME_SIZE = 'size'
export const ATTRIBUTE_NAME_RESISTANCE = 'resistance'
export const ATTRIBUTE_NAME_PATCH_SIZE = 'patch_size'
export const ATTRIBUTE_NAME_NOMINAL_WEIGHT = 'nominal_weight'
export const ATTRIBUTE_NAME_CBD_CONTENT = 'cbd_content'
export const ATTRIBUTE_NAME_ADDITION = 'addition'
export const ATTRIBUTE_NAME_CONSISTENCY = 'consistency'
export const ATTRIBUTE_NAME_ANIMAL_SIZE = 'animal_size'
export const ATTRIBUTE_NAME_PACKAGING_VARIANT = 'packaging_variant'
export const ATTRIBUTE_NAME_COLOR_NUMBER = 'color_number'
export const ATTRIBUTE_NAME_CANNULA_LENGTH = 'cannula_length'
export const ATTRIBUTE_NAME_TUBE_LENGTH = 'tube_length'
export const ATTRIBUTE_NAME_CONTACT_LENSES = 'contact_lenses'
export const ATTRIBUTE_NAME_PACKAGE_SIZE = 'package_size'
